import { getApp } from 'firebase/app';
import { getFunctions, httpsCallable } from 'firebase/functions';

export type TournamentLiveDetailsPatch = {
  name: string;
  description: string;
  visibility: 'private' | 'crew' | 'public';
  groupName?: string;

  locationScope?: 'worldwide' | 'country' | 'region' | 'water' | 'custom';
  locationLabel?: string;
  mapLocation?: {
    lat: number;
    lng: number;
    source?: string;
    label?: string;
  } | null;

  registrationOpensAt?: number;
  registrationClosesAt?: number;
  startDate?: number;
  endDate?: number;

  scoringMode?: string;
  eligibleSpecies?: string[];
  catchLimit?: number;
  minQualifyingSize?: number;
  measurementUnit?: 'in' | 'cm' | 'lb' | 'kg' | 'points';
  entryFeeShells?: number;
  submissionCapturePolicy?: 'live_only' | 'live_or_upload';
  prizeDistribution?: 'winner_take_all' | 'top_three' | 'top_five' | 'team_split';
  rulesText?: string;

  // Cosmetic cover changes never alter tournament scoring/lifecycle.
  coverImageUrl?: string | null;
  coverThumbUrl?: string | null;
  coverImagePath?: string | null;
  coverImageUpdatedAt?: number | null;
  coverImageZoom?: number;
  coverImagePositionX?: number;
  coverImagePositionY?: number;
};

type TournamentLiveDetailsResponse = {
  ok: true;
  tournamentId: string;
  status: string;
  approvalStatus: string;
  sentBackForReview?: boolean;
};

const functions = getFunctions(getApp(), 'us-central1');

const updateDetailsCallable = httpsCallable<
  { tournamentId: string; patch: TournamentLiveDetailsPatch },
  TournamentLiveDetailsResponse
>(functions, 'tournamentUpdateDetails');

export async function updateTournamentLiveDetails(
  tournamentId: string,
  patch: TournamentLiveDetailsPatch,
) {
  const result = await updateDetailsCallable({ tournamentId, patch });
  return result.data;
}
